<template>
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
          <el-form-item prop="nameCn">
                <el-input size="small" v-model="searchForm.nameCn" placeholder="中文名称" clearable></el-input>
          </el-form-item>
          <el-form-item prop="nameEn">
                  <el-input size="small" v-model="searchForm.nameEn" placeholder="英文名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>

     <div class="bg-white top">
        <vxe-toolbar >
          <template #buttons>
            <!-- <el-button v-if="hasPermission('unmsets:cecUnmSets:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button> -->
            <!-- <el-button v-if="hasPermission('unmsets:cecUnmSets:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmSetsTable && $refs.cecUnmSetsTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <!-- <el-button v-if="hasPermission('unmsets:cecUnmSets:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmSetsTable && $refs.cecUnmSetsTable.getCheckboxRecords().length === 0" plain>删除</el-button> -->
            <el-button v-if="hasPermission('unmsets:cecUnmSets:getSetmenu')" @click="getCecProject()" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC套餐数据</el-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 80px);">
        <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmSetsTable"
            show-header-overflow
            show-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `套餐表数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '套餐表数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
            <vxe-column type="seq" width="40"></vxe-column>
            <!-- <vxe-column type="checkbox"  width="40px"></vxe-column> -->
            <!-- <vxe-column
        field="sort"
        width="50px"
        title="排序">
      </vxe-column> -->
    <vxe-column
        field="nameCn"
        show-overflow
        title="中文名称">
            <template slot-scope="scope">
              <div class="textOverflow">
                <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmsets:cecUnmSets:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                <!-- <el-link type="primary" :underline="false" v-if="hasPermission('unmsets:cecUnmSets:view')"  @click="view(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                <span class="linkSpan" v-if="hasPermission('unmsets:cecUnmSets:view')"  @click="view(scope.row.id)">{{scope.row.nameCn}}</span>
                <span v-else>{{scope.row.nameCn}}</span>
              </div>
            </template>
      </vxe-column>
    <vxe-column
        field="nameEn"
        title="英文名称">
      </vxe-column>
    <vxe-column
        field="num"
        title="项目数量">
      </vxe-column>
    <vxe-column
        field="targetPrice"
        title="套餐价格">
      </vxe-column>
    
    <vxe-column
        field="type"
        title="类型">
        <template slot-scope="scope">
              {{ $dictUtils.getDictLabel("sets_type", scope.row.type, '-') }}
        </template>
      </vxe-column>
      <vxe-column
        fixed="right"
        align="center"
        width="200"
        title="操作">
        <template  slot-scope="scope">
          <router-link :to="{path: '/unmsets/CecUnmSetsProject', query: {  id: scope.row.id }}" :disabled="hasPermission('unmsets:cecUnmSets:view')">
            <el-button v-if="hasPermission('unmsets:cecUnmSets:view')" type="text" size="small">套餐项目</el-button>
          </router-link>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager>
    </div>
    </div>
        <!-- 弹窗, 新增 / 修改 -->
    <CecUnmSetsForm  ref="cecUnmSetsForm" @refreshDataList="refreshList"></CecUnmSetsForm>
  </div>
</template>

<script>
  import CecUnmSetsForm from './CecUnmSetsForm'
  import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          nameCn: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'sort', asc: false }]
        },
        loading: false
      }
    },
    components: {
      CecUnmSetsForm
    },
    activated () {
      this.refreshList()
    },
    methods: {
      // 跳转套餐项目列表
      handSetsProject () {

      },
      // 获取cec套餐表数据
      getCecProject () {
        this.loading = true
        cecUnmSetsService.getCecProject({}).then(({res}) => {
          this.$message.success('获取成功')
          this.refreshList()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmSetsService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmSetsForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmSetsForm.init('edit', id)
      },
      // 查看
      view (id) {
        this.$refs.cecUnmSetsForm.init('view', id)
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmSetsService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmSetsService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmSetsService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmSetsService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>
<style scoped lang="less">
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
  .linkSpan {
    cursor: pointer;
    color: #1890FF;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

